export default __webpack_public_path__ + "static/media/rain-2-day.69c653af.svg";